import React from 'react'
import Form from './Components/Form/Form'

import Header from './Components/Header/Header'

function App () {
  return (
    <div className='App'>
      <Header />
      <Form />

    </div>
  )
}

export default App
